import SideBar from "components/SideBar/index";
import Markdown from "react-markdown";

const ABOUT_DESCRIPTION = `
This app is still in beta, please report bugs and reach out with questions!
`;

const About = () => {
  return (
    <div className="default relative h-screen bg-repeat bg-palette-4 overflow-hidden">
      <div className="h-screen w-screen flex flex-row">
        <div className="bg-palette-4">
          <SideBar />
        </div>
        <div className="bg-palette-4 text-palette-2 p-20">
          <Markdown>{ABOUT_DESCRIPTION}</Markdown>
        </div>
      </div>
    </div>
  );
};

export default About;
